import { useRef } from 'react';
import { useEffect } from 'react';
import { Animated, Easing, TouchableOpacity } from 'react-native';

import { useThemeColor } from './Themed';

interface Props {
    value: boolean;
    onChange: (value: boolean) => void;
    accessibilityLabel: string;
    accessibilityHint?: string;
    disabled?: boolean;
    testID?: string;
}

const Switch = ({
    value,
    onChange,
    accessibilityLabel,
    accessibilityHint,
    disabled = false,
    testID
}: Props) => {
    const translateAnimation = useRef(new Animated.Value(0)).current;
    const onColor = useThemeColor('primary.main');
    const offColor = useThemeColor('grey');
    const disabledColor = useThemeColor('text.disabled');

    useEffect(() => {
        Animated.timing(translateAnimation, {
            toValue: value ? 20 : 0,
            duration: 200,
            easing: Easing.cubic,
            useNativeDriver: false
        }).start();
    }, [value]);

    return (
        <TouchableOpacity
            disabled={disabled}
            onPress={() => onChange(!value)}
            accessibilityLabel={accessibilityLabel}
            accessibilityHint={accessibilityHint}
            accessibilityRole="switch"
            accessibilityState={{ checked: value, disabled }}
            accessible
            activeOpacity={1.0}
            testID={testID}
            style={{
                width: 51,
                height: 31,
                borderRadius: 15.5,
                backgroundColor: disabled ? disabledColor : value ? onColor : offColor
            }}
        >
            <Animated.View
                style={{
                    width: 27,
                    height: 27,
                    borderRadius: 13.5,
                    backgroundColor: useThemeColor('white'),
                    top: 2,
                    left: 2,
                    transform: [{ translateX: translateAnimation }]
                }}
            />
        </TouchableOpacity>
    );
};

export default Switch;
